import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const UserLogin = () => {
  const [userId, setUserId] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const { userLogin } = useAuth();
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({
    userId: "",
    password: "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    // console.log("Submitting user login with userId:", userId);
    try {
      const userData = await userLogin(userId, password);
      // console.log("User login response:", userData);
      if (userData) {
        // console.log("User login successful, navigating to his/her dashboard");
        navigate(`/${userData.userId}`);
      } else {
        // console.log("User login failed, setting generic error");
        setError("Invalid User ID or Password");
      }
    } catch (err) {
      console.error("User login error:", err.response?.data || err);
      setError(
        err.response?.data?.message || "Login failed. Please try again."
      );
    }
  };

  return (
    <div className="card main-content max-w-xl">
      <p>Please login to your account.</p>
      <h2>Client Login</h2>
      {error && <div className="alert alert-danger">{error}</div>}
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label>Unique User ID</label>
          <input
            value={userId}
            onChange={(e) => setUserId(e.target.value)}
            className="input"
            required
          />
        </div>
        <div className="mb-3">
          <label>Your ID Password</label>
          <input
            name="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="input"
            required
          />
        </div>
        <button type="submit" className="btn btn-primary w-full">
          Login
        </button>
      </form>
    </div>
  );
};

export default UserLogin;
